import siteLogo from '@/assets/aero-logo.png';
import siteConfig from './site';

// 全站统一品牌 Logo 资源
export const brandLogo = siteLogo;
export const brandLogoPath = siteConfig.logoPath;

export const brandAssetMap = {
  [brandLogoPath]: siteLogo,
};
